module.exports = __webpack_public_path__ + "static/img/paifeng.31c4e9d1.png";